import {
  booleanAttribute,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'app-button-card',
  templateUrl: './button-card.component.html',
  styleUrl: './button-card.component.scss',
  standalone: false,
})
export class ButtonCardComponent {
  selected = input(false, {
    transform: booleanAttribute,
  });

  disabled = input(false, {
    transform: booleanAttribute,
  });

  fullSize = input(false, {
    transform: booleanAttribute,
  });

  handleClick = output<MouseEvent>();
  handleKeyEnter = output<KeyboardEvent>();

  cardClass = computed(() => {
    const baseClasses = 'border rounded-lg';
    const activeClasses = this.selected()
      ? 'border-primary-500 bg-primary-100/5'
      : '';
    const hoverClasses = !this.disabled()
      ? 'hover:border-primary-500 hover:bg-primary-100/5'
      : '';
    const stateClasses = this.disabled()
      ? 'opacity-50 cursor-not-allowed'
      : 'cursor-pointer';

    return `${baseClasses} ${activeClasses} ${hoverClasses} ${stateClasses}`;
  });

  emitClick($event: MouseEvent) {
    if (!this.disabled()) {
      this.handleClick.emit($event);
    }
  }

  emitKeyEnter($event: KeyboardEvent) {
    if (!this.disabled() && $event.key === 'Enter') {
      this.handleKeyEnter.emit($event);
    }
  }
}
